const bannerKey = (configId: string) =>
	`riskTemplateBannerDismissed:${configId}`;
const summaryKey = (configId: string, section: 'lof' | 'cof') =>
	`riskTemplateMissingSummaryDismissed:${configId}:${section}`;

// Reads run during render. When storage is blocked outright, even accessing
// localStorage throws, so fail closed (banner shows) rather than crash the tab.
export const isTemplateBannerDismissed = (configId: string): boolean => {
	try {
		return localStorage.getItem(bannerKey(configId)) === '1';
	} catch {
		return false;
	}
};

export const dismissTemplateBanner = (configId: string): void => {
	try {
		localStorage.setItem(bannerKey(configId), '1');
	} catch {
		// Best-effort persistence — private browsing, quota limits, or
		// storage policies can make setItem throw. The dismissal should
		// still apply for the current session either way.
	}
};

// Fails closed for the same reason as isTemplateBannerDismissed.
export const isMissingSummaryDismissed = (
	configId: string,
	section: 'lof' | 'cof',
): boolean => {
	try {
		return localStorage.getItem(summaryKey(configId, section)) === '1';
	} catch {
		return false;
	}
};

export const dismissMissingSummary = (
	configId: string,
	section: 'lof' | 'cof',
): void => {
	try {
		localStorage.setItem(summaryKey(configId, section), '1');
	} catch {
		// Best-effort persistence — see dismissTemplateBanner.
	}
};
